export const APP_STORE_URL = "https://apps.apple.com/app/id6761488910";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.groupeo.app";
